module.exports = __webpack_public_path__ + "img/ico_lodging_select@2x.012b9dc0.png";